import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { filterSectionsByRole, isNavItemActive, NAV_SECTIONS } from './navigation.config';
import type { UserRole } from '../../types';

/* Logo, quick-links and the profile menu now live in the sidebar (Navigation.tsx).
   All that's left here is the mobile nav trigger — the sidebar is hidden on
   narrow screens, so this is the only way to reach navigation there. */
const TopHeader: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const filteredSections = useMemo(
    () => filterSectionsByRole(NAV_SECTIONS, user?.role as UserRole | undefined),
    [user?.role]
  );

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const target = e.target as Node;
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(target)) setMobileMenuOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <header className="top-header">
      <div className="top-header-actions">
        <div className="top-header-dropdown-wrap top-header-mobile-menu-wrap" ref={mobileMenuRef}>
          <button
            type="button"
            className="top-header-btn"
            title="Цэс"
            onClick={() => setMobileMenuOpen((v) => !v)}
          >
            {mobileMenuOpen ? <X size={16} /> : <Menu size={16} />}
          </button>
          {mobileMenuOpen && (
            <div className="top-header-dropdown top-header-mobile-menu">
              {filteredSections.map((section) => (
                <div key={section.id} className="top-header-mobile-menu-section">
                  <div className="top-header-mobile-menu-title">{section.label}</div>
                  {section.items.map((item) => {
                    const active = isNavItemActive(location.pathname, item);
                    return (
                      <Link
                        key={item.path}
                        to={item.path}
                        className={`top-header-mobile-menu-item ${active ? 'active' : ''}`}
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <item.icon size={14} />
                        <span>{item.label}</span>
                      </Link>
                    );
                  })}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
